// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"ceee9e9a","4702":"163fbdbf","5243":"ceee9e9a"}[chunkId] + ".chunk.css";
};